/* ========================================================================
 * Apricot's Filters
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-base.scss';
import '../scss/includes/filter.scss';

import Popover from './CBPopover'
import Utils from './CBUtils'

/**
 * Filter Popover
 *
 * @export
 * @param {Object} data 
 * @param {Element} data.elem
 * @param {Element} data.popoverNode
 * @param {String} data.placement
 * @param {String} data.flipVariations
 * @param {Array} data.offset
 * @param {Number|Object} data.delay 
 * @param {Boolean} data.closeOnClickOutside
 * @param {Function} data.onShow
 * @param {Function} data.onHide
 * @returns {{hide: Function}} 
 * @returns {{show: Function}} 
 * @returns {{updateTrigger: Function}} 
 * @returns {{destroy: Function}} 
 */

const CBFilter = (data = {}) => {
	const defaultData = {
		elem: null,
		popoverNode: null,
		placement: 'bottom-start',
		flipVariations: 'top-start',
		offset: [0, 8],
		delay: {
			show: 200,
			hide: 100
		},
    closeOnClickOutside: true,
		onShow: null,
		onHide: null
	}
	data = {
		...defaultData,
		...data
	};

	let elem = data.elem;
	if (!Utils.elemExists(elem)) return null;

	let popoverNode = null;
	let triggerLabel = elem.innerHTML.trim();


	let popoverIns = null
	const init = () => {
		elem.filter = 'cb';
		popoverNode = data.popoverNode || document.querySelector(`#${elem.getAttribute('aria-controls')}`)

		triggerLabel = elem.innerHTML.trim();
		
		popoverIns = Popover({
			elem: elem,
			popoverNode: popoverNode,
			placement: data.placement,
			flipVariations: data.flipVariations,
			offset: data.offset,
			delay: data.delay,
			closeOnClickOutside: data.closeOnClickOutside,
			filter: true
		});

		elem.addEventListener('click', (e) => {
			e.preventDefault();

			if (Utils.hasClass(elem, 'cb-filter-open')) {
				popoverHide(e)
			} else {
				popoverShow(e)
			}
		})

		elem.addEventListener('apricot_popover_hide', (e) => {
			popoverHide(e)
		})
	}
	const popoverShow = (e) => {
		data.onShow && data.onShow(e)
		Utils.addClass(elem, 'cb-filter-open')
	}
	const popoverHide = (e) => {
		data.onHide && data.onHide(e)
		Utils.removeClass(elem, 'cb-filter-open')
	}
	const hide = () => {
		popoverIns.hide();
	}
	const show = () => {
		popoverIns.show();
	}

  /**
   * Updates the label for trigger
   * @method CBFilter#updateTrigger
   * @memberof CBFilter
   * @param {Number} count - Number of selected filters
   * @param {String} label - Actual label of the trigger (optional)
   */
	const updateTrigger = (count = 0, label = null) => {
		let newLabel  = triggerLabel
		if (label) newLabel = label;

		if (count > 0) {
			newLabel = `${newLabel} (${count})`
		} else {
			newLabel  = triggerLabel
		}
		elem.innerHTML = newLabel 

		if (triggerLabel !== newLabel) {
			Utils.addClass(elem, 'cb-filter-active')
		} else {
			Utils.removeClass(elem, 'cb-filter-active')
		}
	}

	const destroy = () => {
		if (elem.filter === 'cb') {
			elem.filter = null
		}
	}

	if (elem.filter !== 'cb') {
		init();
	}

	return {
		hide: hide,
		show: show,
		updateTrigger: updateTrigger,
		destroy: destroy
	}
}


export default CBFilter;